import React from "react"

class RateDataType extends React.Component{

  constructor(props) {
    super(props);
  }

  render() {
    var self = this;

    if (self.props.data && self.props.data != "") {

      if (self.props.row.billing_policy_path) {
        return <div><a className="modal-iframe" data-fullscreen={true} href={self.props.row.billing_policy_path}>{self.props.data}</a></div >
      } else {
        return <li>{self.props.data}</li>
      }
    } else{
      return null;
    };
  };
};

export default RateDataType